import { ClockCircleOutlined } from '@ant-design/icons';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import { ColumnBaseProps } from '../types';

import s from './SetupIndicatorColumn.module.scss';

const SetupIndicatorColumn: React.FC<ColumnBaseProps> = ({ record }) => {
  if (record.catalogField?.setupRequired) {
    return <ClockCircleOutlined className={s.column} />;
  }

  return null;
};

export default observer(SetupIndicatorColumn);
